import type { ValidationIssue } from '../types';

const PIPING_SPEC_COMPLETION_VALIDATION_ID = 13;

export function scopePipingSpecQuickFixToFamily(
  issue: ValidationIssue,
  impactedElementIds: string[]
): ValidationIssue {
  if (
    issue.ValidationId !== PIPING_SPEC_COMPLETION_VALIDATION_ID ||
    impactedElementIds.length === 0
  ) {
    return issue;
  }

  const elementIds = Array.from(new Set(impactedElementIds));
  const affectedElements = elementIds.map((elementId) => {
    const issueElementIndex = issue.ElementIds.indexOf(elementId);
    return issue.AffectedElements[issueElementIndex] ?? `Element ${elementId}`;
  });

  return {
    ...issue,
    ElementIds: elementIds,
    AffectedElements: affectedElements,
  };
}
